import { render, staticRenderFns } from "./priceIndex.vue?vue&type=template&id=68b4b6a7&scoped=true&"
import script from "./priceIndex.vue?vue&type=script&lang=js&"
export * from "./priceIndex.vue?vue&type=script&lang=js&"
import style0 from "./priceIndex.vue?vue&type=style&index=0&id=68b4b6a7&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b4b6a7",
  null
  
)

export default component.exports